import { Home, Calendar, PaperPlus, Graph, Swap, Paper, Notification } from "react-iconly";
import {FiDatabase} from "react-icons/fi";
import IntlMessages from "../../layout/components/lang/IntlMessages";


const main = [
    {
        header: <IntlMessages id="sidebar-main" />,
    },
    {
        id: "sidebar-dashboard-eCommerce",
        title: <IntlMessages id="sidebar-dashboard-eCommerce" />,
        icon: <Home set="curved" />,
        navLink: "/travel-dashboard",
    },
    {
        id: "sidebar-new-travel-request",
        title: <IntlMessages id="sidebar-new-travel-request" />,
        icon: <PaperPlus set="curved" />,
        navLink: "/travel-dashboard/travel-request",
    },
    {
        id: "sidebar-new-travel-table",
        title: <IntlMessages id="sidebar-new-travel-table" />,
        icon: <Paper set="curved" />,
        navLink: "/travel-dashboard/travel-table",
    },
    {
        id: "sidebar-notification-list",
        title: <IntlMessages id="sidebar-notification-list" />,
        icon: <Notification set="curved"/>,
        navLink: "/notification-list",
    },
    {
        id: "sidebar-dashboard-options",
        title: <IntlMessages id="sidebar-dashboard-options" />,
        icon: <Swap set="curved"/>,
        navLink: "/dashboard-options",
    }
];


export default main